const div = document.createElement("div");

export function stripHTML(value: string | undefined) {
  if (!value) {
    return "";
  }

  div.innerHTML = value;
  return div.textContent ?? div.innerText ?? value ?? "";
}
